import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "teacher_token";
// localStorage (persistent across tabs/sessions) — used as a fallback for the
// trusted-device token, because the primary HTTP-only cookie can be lost on
// cross-domain previews. The token is bcrypt-hashed in DB, so its theft only
// allows skipping the 2FA OTP for this account — the password is still required.
const TRUSTED_DEVICE_KEY = "trusted_device_token";

// Use sessionStorage: cleared when tab closes, not shared across tabs.
// Reduces XSS persistence vs localStorage. Cookies set by backend are httpOnly
// so axios doesn't see them; we send Authorization: Bearer for stateful calls.
const storage = typeof window !== "undefined" ? window.sessionStorage : null;
const persistent = typeof window !== "undefined" ? window.localStorage : null;

export function getToken() {
  return storage ? storage.getItem(TOKEN_KEY) : null;
}
export function setToken(t) {
  if (storage) storage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  if (storage) storage.removeItem(TOKEN_KEY);
}

export function getTrustedDeviceToken() {
  return persistent ? persistent.getItem(TRUSTED_DEVICE_KEY) : null;
}
export function setTrustedDeviceToken(t) {
  if (persistent && t) persistent.setItem(TRUSTED_DEVICE_KEY, t);
}
export function clearTrustedDeviceToken() {
  if (persistent) persistent.removeItem(TRUSTED_DEVICE_KEY);
}

const teacherClient = axios.create({ baseURL: API, withCredentials: true });
teacherClient.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const td = getTrustedDeviceToken();
  if (td) cfg.headers["X-Trusted-Device"] = td;
  return cfg;
});

export const teacherApi = teacherClient;
export const publicApi = axios.create({ baseURL: API, withCredentials: true });
// publicApi must also forward trusted device token to the login endpoint.
publicApi.interceptors.request.use((cfg) => {
  const td = getTrustedDeviceToken();
  if (td) cfg.headers["X-Trusted-Device"] = td;
  return cfg;
});

/**
 * Full logout: clear sessionStorage AND backend cookies. Call this whenever
 * the user wants to switch accounts.
 */
export async function logout() {
  try {
    await teacherClient.post("/auth/logout");
  } catch { /* even if backend fails, clear locally */ }
  clearToken();
}
